import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-unknown-upload-error',
  templateUrl: './modal-unknown-upload-error.component.html',
  styleUrls: ['./modal-unknown-upload-error.component.scss']
})
export class ModalUnknownUploadErrorComponent implements OnInit {

  errorName?: string;
  errorMessage?: string;
  requestId?: string;

  constructor(private router: Router, public ref: DialogRef) {
    this.errorName = this.ref.data.errorName;
    this.errorMessage = this.ref.data.errorMessage;
    this.requestId = this.ref.data.requestId;
  }

  ngOnInit(): void { }

  retry() {
    this.ref.close();
    this.router.navigate(['/']);
  }

}
